const _setup_facebook_button = (el, url, title) => {
    const url_encoded = encodeURIComponent(url || el.dataset.url || "");
    el.href = `https://www.facebook.com/sharer/sharer.php?u=${url_encoded}`;
};
const _setup_twitter_button = (el, url, title) => {
    const url_encoded = encodeURIComponent(url || el.dataset.url || "");
    const title_encoded = encodeURIComponent(title || el.dataset.title || "");
    el.href = `https://twitter.com/intent/tweet?url=${url_encoded}&text=${title_encoded}`;
};
const _setup_pinterest_button = (el, url, title, media_url) => {
    const url_encoded = encodeURIComponent(url || el.dataset.url || "");
    const title_encoded = encodeURIComponent(title || el.dataset.title || "");
    const media_url_encoded = encodeURIComponent(media_url || el.dataset.mediaUrl || "");
    el.href = `https://pinterest.com/pin/create/button?media=${media_url_encoded}&url=${url_encoded}&description=${title_encoded}`;
};

const setup_share_buttons = (container, url = "", title = "", media_url = "") => {
    container.querySelectorAll('a.share-button--facebook').forEach(el => _setup_facebook_button(el, url, title, media_url));
    container.querySelectorAll('a.share-button--twitter').forEach(el => _setup_twitter_button(el, url, title, media_url));
    container.querySelectorAll('a.share-button--pinterest').forEach(el => _setup_pinterest_button(el, url, title, media_url));
};

export default setup_share_buttons;
export {
    setup_share_buttons,
};
